import React from "react";
import {DashboardCard} from "../../../../designSystem/components/DashboardCard";
import {Typography} from "../../../../designSystem/components/Typography";
import {FilePreview} from "../FilePreview";
import {APPLICATION_ATTACHMENTS} from "../../../../utils/constants";
import {ICase} from "../../../../types/Case";

interface ApplicationAttachmentsViewProps {
  caseData: ICase;
}

export const ApplicationAttachmentsView = ({
  caseData
}: ApplicationAttachmentsViewProps) => (
  <DashboardCard>
    {/* Uploaded Files */}
    <Typography variant="subtitle">
      文件
    </Typography>
    {Object.keys(APPLICATION_ATTACHMENTS).map(key => {
      const keyUrl = `${key}Url`
      if (!caseData[keyUrl]) return null;
      return (
        <div
          className={"mb-4"}
          key={APPLICATION_ATTACHMENTS[key].label}
        >
          <p className="text-sm text-gray-600 mb-2">
            {APPLICATION_ATTACHMENTS[key].label}
          </p>
          <FilePreview
            fileUrl={caseData[keyUrl]}
            label={APPLICATION_ATTACHMENTS[key].label}
          />
        </div>
      )
    })}
  </DashboardCard>
)
